<section class="container"></section>

<section class="brand-section">
  <div class="brand-container">
    <h1>Your Brand. Our Power.</h1>
    <p>
      Deliver services and products under your own brand identity. With MALtech
      Branded Solutions, you stay in the spotlight while we power the
      technology, design, and integration.
    </p>
    <div class="brand-buttons">
      <a routerLink="/contact" href="/contact" class="btn-primary"> Start Your Branded Solution </a>
      <a
        rel="noopener noreferrer"
        routerLink="/service/software-development"
        href="/service/software-development"
        class="btn-secondary text-decoration-none"
        aria-label="Explore Services & Products"
      >
        Explore Services & Products
      </a>
    </div>
  </div>
</section>

<section class="solutions-section">
  <div class="container">
    <h2>Why Branded Solutions Matter</h2>
    <div class="solutions-cards">
      <div class="card" *ngFor="let item of solutions">
        <h3>{{ item.title }}</h3>
        <p>{{ item.description }}</p> 
      </div>
    </div>
  </div>
</section>

<section class="services-section" id="products">
  <div class="container">
    <h2>Branded Services & Solutions</h2>
    <div class="services-grid row">
      <div class="service-col mb-4" *ngFor="let service of services">

        <div class="card h-100 text-center p-3">
          <i class="bi {{ service.icon }} service-icon mb-3"  id="serviceIcon"></i>
          <h3>{{ service.title }}</h3>
          <p>{{ service.description }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="deliver-section">
  <div class="container">
    <h2 class="section-title">How We Deliver</h2>

    <div class="stepper">
      <div class="step" *ngFor="let step of steps; let i = index">
        <div class="icon-wrapper">
          <div class="circle">
  <i class="bi" [ngClass]="step.icon"></i>
</div>
          <span class="line" *ngIf="i !== steps.length - 1"></span>
        </div>
        <div class="content">
          <h3>{{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="benefits">
  <div class="container">
    <h2>Benefits of <span>MALtech</span> Branded Solutions</h2>

    <div class="benefits-grid">
      <div class="benefit" *ngFor="let benefit of benefits">
        <span class="check">✓</span>
        <p>{{ benefit.text }}</p>
      </div>
    </div>
  </div>
</section>

<section class="why-choose">
  <div class="container">
    <h2>Why Choose <span>MALtech</span></h2>

    <div class="reasons-grid">
      <div class="reason" *ngFor="let reason of reasons">
        {{ reason.text }}
      </div>
    </div>
  </div>
</section>

<section class="build-brand-solutions">
  <div class="container">
    <div class="container-solutions">
      <h2>Let’s Build Intelligent Solutions Together</h2>
      <p>
        Partner with MALtech to transform your business with powerful SEO,
        social media campaigns, and result-driven marketing strategies.
      </p>
      <a [routerLink]="['/contact']" [href]="['/contact']" class="btn text-decoration-none btn-primary" aria-label="Contact Us"
        >Contact Us </a
      >
    </div>
  </div>
</section>
